import { render, staticRenderFns } from "./crudServices.vue?vue&type=template&id=6581e2cc&scoped=true"
import script from "./crudServices.vue?vue&type=script&lang=js"
export * from "./crudServices.vue?vue&type=script&lang=js"
import style0 from "./crudServices.vue?vue&type=style&index=0&id=6581e2cc&prod&lang=css"
import style1 from "./crudServices.vue?vue&type=style&index=1&id=6581e2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581e2cc",
  null
  
)

export default component.exports